import { MeetingRoomResponse } from "../../model/meetingRoomResponse";
import { getPhoneNumberE164 } from "../../utils/general-helpers";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = MeetingRoomResponse;

type fetchResponseType = {
  data?: DtoType[];
  error?: string;
};

export type TransformedDataType = DtoType & {
  phoneNumberX: string;
};

export type GuiResponseType = {
  data?: TransformedDataType[];
  error?: string;
};

export async function getMeetingRoomsData(): Promise<GuiResponseType> {
  try {
    const response: fetchResponseType = await fetchGetJSON(
      apiUrls.getMeetingRooms
    );
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const responseX = response.data.map((item) => {
        return {
          ...item,
          phoneNumberX: getPhoneNumberE164(item.phoneNumber),
        };
      });
      return { data: responseX };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error fetching meeting rooms:", err);
    return { error: (err as Error).message };
  }
}
